import axios from 'axios';
import { Storage } from '@capacitor/storage';

// state
const state = {
  user: (window.localStorage.getItem('user')) ? JSON.parse(window.localStorage.getItem('user')) : {},
  stat: (window.localStorage.getItem('userStat')) ? JSON.parse(window.localStorage.getItem('userStat')) : {},
  accessToken: global.accessToken || window.accessToken || window.localStorage.getItem('access_token') || null,
  expires: global.expires || window.expires || window.localStorage.getItem('expires_in') || null,
  currentGroup: global.currentGroup || window.currentGroup || window.localStorage.getItem('current_group') || null
};

// getters
const getters = {
  user: status => status.user,
  stat: status => status.stat,
  token: status => status.accessToken,
  check: status => status.user && status.user.id,
  expire: status => status.expires,
  currentGroup: status => status.currentGroup,
  currentGroupName: status => (status.user && status.user.groups && status.user.groups.find((e) => e.id === status.currentGroup))
    ? status.user.groups.find((e) => e.id === status.currentGroup).name : null
};

// mutations
const mutations = {
  saveToken (currState, data) {
    const tmpState = currState;
    tmpState.accessToken = data.access_token;
    tmpState.expires = data.expires_in;

    Storage.set({
      key: 'access_token', 
      value: data.access_token
    });
    Storage.set({
      key: 'expires_in', 
      value: data.expires_in
    });
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('expires_in', data.expires_in);
  },

  fetchUserSuccess (currState, { user }) {
    const tmpState = currState;
    tmpState.user = user;
  },

  fetchUserFailure (currState) {
    const tmpState = currState;
    tmpState.accessToken = null;

    Storage.remove({key: 'access_token'});
    Storage.remove({key: 'expires_in'});
    Storage.remove({key: 'current_group'});
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('current_group');
  },

  fetchUserStatSuccess (currState, { stat }) {
    const tmpState = currState;
    tmpState.stat = stat;
  },

  readNewNotification (currState) {
    const tmpState = currState;
    tmpState.stat.notifications = Math.max(currState.stat.notifications - 1, 0);
  },

  logout (currState) {
    const tmpState = currState;
    tmpState.user = {};
    tmpState.accessToken = null;

    Storage.remove({key: 'access_token'});
    Storage.remove({key: 'expires_in'});
    Storage.remove({key: 'current_group'});
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('current_group');
  },

  updateUser (currState, { user }) {
    const tmpState = currState;

    tmpState.user = user;
  },

  changeGroup (currState, { id }) {
    const tmpState = currState;
    tmpState.currentGroup = id;

    if (id) {
      Storage.set({
        key: 'current_group',
        value: id
      });
      localStorage.setItem('current_group', id);
    } else {
      Storage.remove({key: 'current_group'});
      localStorage.removeItem('current_group');
    }
  }
};

// actions
const actions = {
  saveToken ({ commit }, payload) {
    commit('saveToken', payload);
  },

  async fetchUser ({ commit, dispatch, state }) {
    try {
      const { data } = await axios.get('/user/me');
      window.localStorage.setItem('user', JSON.stringify(data));
      commit('fetchUserSuccess', { user: data });
    } catch (e) {
      const user = window.localStorage.getItem('user');

      if (user) {
        commit('fetchUserSuccess', { user: JSON.parse(user) });
      } else {
        commit('fetchUserFailure');
      }
    }

    try {
      const params = {};

      if (state.currentGroup) {
        params.group = state.currentGroup;
      }

      const { data } = await axios.get('/user/stat', {
        params
      });
      window.localStorage.setItem('userStat', JSON.stringify(data));
      commit('fetchUserStatSuccess', { stat: data });
    } catch (e) {
      const stat = window.localStorage.getItem('stat');

      if (stat) {
        commit('fetchUserStatSuccess', { stat: JSON.parse(stat) });
      }
    }
  },

  updateUser ({ commit, dispatch }, payload = {}) {
    commit('updateUser', payload);
  },

  async logout ({ state, commit }, { pouch } = {}) {
    try {
      window.localStorage.removeItem('user');

      if (pouch) {
        await pouch.destroy('projects');
        await pouch.destroy('project_data');
      }
    } catch (e) {
      console.error(e);
    }

    commit('logout');
  },

  async fetchOauthUrl (ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`);

    return data.url;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
